import React from 'react';
import { Link } from 'react-router-dom';

// Public site footer — displays only verified content from platform settings.
// Legal pages (Privacy / Terms) are rendered only when we have confirmed
// content available. See PrivacyPage.jsx / TermsPage.jsx.
const PUBLIC_PHONE = '(863) 288-0577';
const YEAR = new Date().getFullYear();

export default function PublicFooter() {
  return (
    <footer className="bg-[#0a1f47] text-slate-200 mt-24" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <img
            src="/brand/kr-logo-dark.webp"
            alt="KR Enterprise Group — Health & Life Insurance Services"
            className="h-16 w-auto"
            width="320"
            height="120"
          />
          <p className="mt-5 text-sm text-slate-300 max-w-md leading-relaxed">
            KR Enterprise Group supports independent insurance agents and agencies with
            contracting assistance, carrier access, training, and technology built for daily
            agency operations.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/#why-kr" className="hover:text-white transition-colors">Why KR</Link></li>
            <li><Link to="/#agency-hub" className="hover:text-white transition-colors">KR Agency Hub</Link></li>
            <li><Link to="/#training" className="hover:text-white transition-colors">Training &amp; Resources</Link></li>
            <li><Link to="/events" className="hover:text-white transition-colors">Events</Link></li>
            <li><Link to="/become-an-agent" className="hover:text-white transition-colors">Become an Agent</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">Agent Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">Contact</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a href={`tel:${PUBLIC_PHONE.replace(/\D/g,'')}`} className="hover:text-white" data-testid="footer-phone">
                {PUBLIC_PHONE}
              </a>
              <div className="text-[11px] text-slate-400">Call or text</div>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-400">
          <div>&copy; {YEAR} KR Enterprise Group. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-terms-link">
              Terms of Use
            </Link>
            <Link to="/refund-policy" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-refund-link">
              Refund &amp; Return Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
